const baseURL = 'https://api.xaou.sn.cn'
const imgUrl = 'https://sxvod.wondernect.com'
const learnUrl = 'http://localhost:8081'
const userImgUpload = '/v1/health/uc/user/upload_avatar' //用户上传头像
const fileUpload = '/v1/health/web/file/common_upload' //文件上传

//存数据
export function setItem(key,value){
  let storage = window.localStorage.getItem(key)
  if(!storage){
    storage = {}
  }else{
    storage = JSON.parse(storage)
  }
  storage[key] = value
  window.localStorage.setItem(key,JSON.stringify(storage))
}

//取数据
export function getItem(key,def){
  let storage = window.localStorage.getItem(key)
  if(!storage){
    return def
  }
  storage = JSON.parse(storage)
  let result = storage[key]
  return result || def
}

export function getImgPath(){
	//获取当前网址
	var curWwwPath=window.document.location.href;
	//获取主机地址之后的目录
	var pathName=window.document.location.pathname;
  console.log(pathName)
	var pos=curWwwPath.indexOf(pathName);
	//获取地址到端口号
	var localhostPath=curWwwPath.substring(0,pos);
	//项目名
	var projectName=pathName.substring(0,pathName.substr(1).indexOf('/')+1);
	if("win"==os){
		return localhostPath + projectName;
	}else{
		return localhostPath;
	}
}

/**
 * 格式化日期 格式后为：2019-02-14
 * */
export function fmtDate(obj){
  var date =  new Date(obj);
  var y = 1900+date.getYear();
  var m = "0"+(date.getMonth()+1);
  var d = "0"+date.getDate();
  return y+"-"+m.substring(m.length-2,m.length)+"-"+d.substring(d.length-2,d.length);
}

/**
 * 格式化日期 格式后为：2019-02-14 14:20
 * */
export function timestampToString(timestamp) {
  var time = new Date(timestamp);
  var y = time.getFullYear();
  var m = time.getMonth()+1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm);
}

//时间个位数前面补0
function add0(m){
	return m<10?'0'+m:m
}

// 时间戳
function timestamp(){
	return Date.now()
}

function isMobile() {
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod|android|mobile/i.test(ua);
}

export default {
  baseURL,
  imgUrl,
  learnUrl,
  userImgUpload,
  fileUpload,
  setItem,
  getItem,
  fmtDate,
  timestampToString,
  timestamp,
  isMobile
}
